import { useEffect, useState } from "react";
import { wsGetDniPariente } from "../../../../context/Actions/grupoFamiliar/grupoFamiliar";
import "./InputAddModal.css";
import { useContext } from "react";
import { PortalContext } from "../../../../context/Provider";
const InputAddModal = ({setForm, form}) => {
    const { grupoFamiliarDispatch, grupoFamiliarState} = useContext(PortalContext);

    // estado para verificar si hay un error 
    const [state, setState] = useState({error: false, data:""})
 
    // cración del useEffect
    useEffect(()=> {

        if(grupoFamiliarState.grupoFamiliar.familiar.error) setState({...state, error: true});
        if(!grupoFamiliarState.grupoFamiliar.familiar.error) setState({...state, error: false});
        
        // rellena el fomulario
        if(!grupoFamiliarState.grupoFamiliar.familiar.error && !grupoFamiliarState.grupoFamiliar.familiar.loading){
            setForm({...form, nro_documentoFamiliar: state.data,  idpaciente2: grupoFamiliarState.grupoFamiliar.familiar.data.codigo ,idpaciente2_desc: grupoFamiliarState.grupoFamiliar.familiar.data.nombre });
        }else setForm({...form, nro_documentoFamiliar: null,idpaciente2:0, idpaciente2_desc:""});
    
    },[grupoFamiliarState.grupoFamiliar.familiar,grupoFamiliarState.grupoFamiliar.familiar.loading ])


    // escucha cuando se escribeun número 
    const onChangeDNI = (c) => {
       let number = JSON.stringify(c.target.value);

        setState({...state, data: JSON.parse( number)})

       // validación de la persona
       if(number.length > 8){
        wsGetDniPariente(JSON.parse(number))(grupoFamiliarDispatch)
       }  
    }

   
    
    return (
        <>
         <div>
                <input
                 value={state.data}
                 autoComplete="off"
                 onChange={onChangeDNI}
                 type="number"
                 min="0"
                 className={`ptur-InputAddModal bgc-grey97 ${grupoFamiliarState.grupoFamiliar.familiar.error ?("error"):("")}`}
                 placeholder="ej: 12345678"
                 />
                <span className="ptur-InputAddModal-txt">
                    {
                        grupoFamiliarState.grupoFamiliar.familiar.loading ? ("Loading..."):
                        grupoFamiliarState.grupoFamiliar.familiar.data.nombre
                    }
                </span>
        </div>
        {
            grupoFamiliarState.grupoFamiliar.familiar.error ? ( 
                <span className="ptur-InputAddModal-p-ERROR">
                   
                    {
                     typeof grupoFamiliarState.grupoFamiliar.familiar.error === "number" ? 
                     "No se encuentran pacientes bajo el número de documento ingresado": 
                      grupoFamiliarState.grupoFamiliar.familiar.error
                    }
                </span>):
            ""
        }
        </>
    )
}

export default InputAddModal; 
